import storage from 'store'
import store from 'vx/store'

export const roles = {
  ADMIN: 'admin',
  HQ_MANAGER: 'hq manager',
  FIREFIGHTER: 'firefighter'
}

export default {
  /**
   * Get token from local storage.
   *
   * @return string
   */
  getToken () {
    return storage.get('token')
  },

  /**
   * Attempt authentication via the token.
   *
   * @return Promise
   */
  attemptViaSession () {
    const { auth } = store.state

    if (
      auth.user.id !== null &&
      auth.user.id !== undefined
    ) {
      return Promise.resolve()
    }

    return store.dispatch('auth/authorize')
  },

  /**
   * Redirect if token has expired.
   *
   * @return void
   */
  async redirectOnSessionExpired () {
    window.location.href = `${process.env.VUE_APP_API_URL}/login`
  },

  /**
   * Redirect to dashboard if a forbidden response is received.
   *
   * @return void
   */
  redirectOnForbidden () {
    window.location.href = process.env.VUE_APP_API_URL
  },

  /**
   * Log the user out. Clear the storage token.
   *
   * @return void
   */
  async logout () {
    if (this.getToken()) {
      try {
        await store.dispatch('auth/deauthenticate')

        storage.remove('token')

        return true
      } catch (error) {
        return false
      }
    }

    return false
  }
}
